module.exports = __webpack_public_path__ + "img/system42-mini.5330d03d.png";